import { TestJsonModel } from '../../test.json.model';

export namespace TestActions {

  export class Delete {
    static readonly type = getActionName('Delete');
    constructor(readonly payload: TestJsonModel) {}
  }

  export class Fetch {
    static readonly type = getActionName('Fetch');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchAppend {
    static readonly type = getActionName('Fetch and append');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch success');
    constructor(readonly payload: TestJsonModel[]) {}
  }

  export class FetchSuccessAppend {
    static readonly type = getActionName('Fetch success append');
    constructor(readonly payload: TestJsonModel[]) {}
  }

  function getActionName(type: string) {
    return `[Test] ${type}`;
  }
}
